var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDeliver(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 28.6127,
    height: 25.0912,
    viewBox: "0 0 28.6127 25.0912",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0107 19.7677C12.3146 20.0718 12.6754 20.3131 13.0726 20.4777C13.4698 20.6423 13.8955 20.727 14.3254 20.727C14.7553 20.727 15.181 20.6423 15.5782 20.4777C15.9754 20.3131 16.3362 20.0718 16.6401 19.7677L20.1427 16.2651C20.3305 16.0574 20.4312 15.7855 20.4241 15.5056C20.4169 15.2256 20.3023 14.9592 20.1041 14.7614C19.9059 14.5636 19.6392 14.4496 19.3593 14.443C19.0793 14.4365 18.8076 14.5378 18.6003 14.726L15.4086 17.9188L15.4162 1.09081C15.4162 0.801513 15.3013 0.52406 15.0967 0.319492C14.8922 0.114925 14.6147 0 14.3254 0V0C14.0361 0 13.7586 0.114925 13.5541 0.319492C13.3495 0.52406 13.2346 0.801513 13.2346 1.09081L13.2248 17.8981L10.0505 14.726C9.84582 14.5215 9.56826 14.4066 9.2789 14.4067C8.98954 14.4068 8.71208 14.5219 8.50754 14.7265C8.303 14.9312 8.18815 15.2088 8.18825 15.4981C8.18836 15.7875 8.3034 16.065 8.50808 16.2695L12.0107 19.7677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M27.5219 24.0004L1.09081 23.9994",
    stroke: "white",
    strokeWidth: 2.18163,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeliver);
export default __webpack_public_path__ + "static/media/icon_deliver.8c87de38c4b9e78b8002c7dda5042cb5.svg";
export { ForwardRef as ReactComponent };